import { FamilyPlanTypes } from '../../common/services/package/package.model';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';

export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('familyPlanMember', {
    component: 'fizyPaycellFamilyPlanMember',
    parent: 'mainWrapper',
    resolve: {
      masterToken: [
        '$stateParams',
        '$q',
        '$state',
        (
          $stateParams,
          $q,
          $state
        ) => {
          if (!$stateParams.masterToken) {
            $state.go("myAccount");
          } else{
            return $stateParams.masterToken;
          }
        }
      ],
      invoice: [
        '$q',
        'globalSpinner',
        ($q, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return globalSpinner.stop();
        }
      ],
      type: [() => { return FamilyPlanTypes.FAMILY; }]
    },
    url: '/family/invite/:masterToken'
  });

  $stateProvider.state('duoPlanMember', {
    component: 'fizyPaycellFamilyPlanMember',
    parent: 'mainWrapper',
    resolve: {
      masterToken: [
        '$stateParams',
        '$q',
        '$state',
        (
          $stateParams,
          $q,
          $state
        ) => {
          if (!$stateParams.masterToken) {
            $state.go("myAccount");
          } else{
            return $stateParams.masterToken;
          }
        }
      ],
      invoice: [
        '$q',
        'globalSpinner',
        ($q, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return globalSpinner.stop();
        }
      ],
      type: [() => { return FamilyPlanTypes.DUO; }]
    },
    url: '/duo/invite/:masterToken'
  });
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-member/family-plan-member.routes.ts